
import Grid from '@mui/material/Grid'; // Importa el componente Grid de Material UI, usado para crear diseños en cuadrícula
import CustomCard from './CustomCard'; // Importa el componente CustomCard, que muestra una tarjeta personalizada

export default function Cards_apps() { // Define el componente funcional Cards
  return (
    <Grid container columns={4} spacing={2} maxWidth="80%" paddingLeft="20%" paddingTop="2%"> {/* Crea un contenedor Grid con 10 columnas, espacio entre elementos y un máximo de ancho del 80% de la pantalla */}
      <Grid item xs={12} sm={6} md={2}> {/* Otra celda para una tarjeta más */}
        <CustomCard path="BinauralKoch.png" title="Sonido de curvas fractales" redirect="curvas-fractales" /> {/* Tarjeta con la imagen, título y redirección de Interact curavas fractales */}
      </Grid>
      <Grid item xs={12} sm={6} md={2}> {/* Celda con tarjeta */}
        <CustomCard path="https://upload.wikimedia.org/wikipedia/commons/c/c9/BiGun.gif" title="Secuenciador: el Juego de la Vida" redirect="secuenciador" /> {/* Tarjeta con la imagen y título de Hilbert's curve */}
      </Grid>
      {/* <Grid item xs={12} sm={6} md={2}> 
        <CustomCard path="b.gif" title="Simetrías de Frisos" redirect="simetrias" /> 
      </Grid> */}
       <Grid item xs={12} sm={6} md={2}> {/* Celda con tarjeta */}
        <CustomCard path="fractalizate.png" title="Fractalízate" redirect="fractalizate" /> 
      </Grid>
    </Grid>
  );
}


